import React from "react";

export default function TempleRakshak() {
  return (
    <>
      <style>{`

      *{
        margin:0;
        padding:0;
        box-sizing:border-box;
      }

      body{
        font-family:"Poppins",sans-serif;
        background:#f3ead7;
      }

      .temple-page{
        width:100%;
        min-height:100vh;
        background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
        color:#222;
        padding:80px 0;
      }

      .container{
        width:92%;
        max-width:1200px;
        margin:auto;
      }

      /* MAIN TITLE */

      .main-title{
        text-align:center;
        margin-bottom:70px;
      }

      .main-title h1{
        font-size:48px;
        font-weight:900;
        color:#000;
        margin-bottom:20px;
        line-height:1.1;
      }

      .main-title h2{
        font-size:36px;
        font-weight:700;
        color:#8b5a00;
        line-height:1.3;
        margin-bottom:35px;
      }

      .main-title p{
        max-width:1000px;
        margin:auto;
        font-size:20px;
        line-height:1.5;
      }

      /* SECTION */

      .section{
        margin-bottom:65px;
      }

      .section-title{
        font-size:40px;
        font-weight:800;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }
      .section-titles{
        font-size:30px;
        font-weight:600;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }

      .section p{
        font-size:20px;
        line-height:1.5;
        margin-bottom:25px;
      }

      .section ul{
        padding-left:25px;
        margin-top:20px;
      }

      .section li{
        font-size:20px;
        line-height:1;
        margin-bottom:14px;
      }

      .price{
        font-size:38px;
        font-weight:700;
        color:#c58b2a;
        margin:20px 0 25px;
      }
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
.intro-image{
  display:flex;
  justify-content:center;
  margin:40px 0 15px;
}

.intro-image img{
  width:100%;
  max-width:900px;
  border:8px solid #fff;
  border-radius:20px;
  box-shadow:
    0 12px 35px rgba(0,0,0,0.18),
    0 0 0 4px #e80707ff;
  transition:0.35s ease;
}

.intro-image img:hover{
  transform:scale(1.02);
  box-shadow:
    0 18px 45px rgba(0,0,0,0.25),
    0 0 0 4px #4a160eff;
}
.membership-box{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:35px;
  margin:35px 0;
  padding:35px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  border-radius:22px;
  border:3px solid #d4af37;
  box-shadow:0 15px 35px rgba(0,0,0,.12);
}

.membership-btn{
  background:linear-gradient(135deg,#c58b2a,#f4c542);
  color:#fff;
  font-size:34px;
  font-weight:800;
  border:none;
  border-radius:18px;
  padding:22px 42px;
  cursor:pointer;
  transition:.35s;
  box-shadow:0 10px 25px rgba(197,139,42,.35);
  text-transform:uppercase;
}

.membership-btn:hover{
  transform:translateY(-4px) scale(1.04);
  box-shadow:0 18px 35px rgba(197,139,42,.45);
}

.payment-info{
  flex:1;
}

.payment-info h3{
  color:#8b5a00;
  font-size:24px;
  margin-bottom:18px;
}

.payment-info p{
  margin:10px 0 !important;
  font-size:20px !important;
  line-height:1.4 !important;
}

.payment-info strong{
  color:#1a2a5a;
}
.payment-row{
  display:flex;
  gap:25px;
  align-items:flex-start;
}

.payment-card{
  flex:1;
  font-size:20px;
  line-height:1.4;
}

.payment-card strong{
  color:#1a2a5a;
  font-size:21px;
}
      /* MOBILE */

@media (max-width: 768px) {
  .intro-image{
    margin:22px 0 10px;
  }

  .intro-image img{
    border:5px solid #fff;
    border-radius:14px;
    box-shadow:
      0 8px 20px rgba(0,0,0,0.18),
      0 0 0 3px #d4af37;
  }
  .temple-page{
    padding:40px 0;
  }

  .container{
    width:95%;
  }

  .main-title{
    margin-bottom:30px;
  }

  .main-title h1{
    font-size:24px;
    line-height:1.1;
    margin-bottom:12px;
  }

  .main-title h2{
    font-size:16px;
    line-height:1.2;
    margin-bottom:16px;
  }

  .main-title p{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .section{
    margin-bottom:32px;
  }

  .section-title{
    font-size:18px;
    line-height:1.2;
    margin-bottom:12px;
  }

  .section-titles{
    font-size:17px;
    line-height:1.2;
    margin-bottom:10px;
  }

  .section p{
    font-size:13px !important;
    line-height:1.4;
    margin-bottom:12px;
  }
  

  .section li{
    font-size:14px;
    line-height:1;
    margin-bottom:8px;
  }

  .section ul{
    padding-left:18px;
  }

  h4{
    font-size:14px;
    margin-bottom:8px;
  }

  .price{
    font-size:28px;
    margin:12px 0;
  }

  .section-divider{
    margin:16px auto 20px;
    gap:10px;
  }

  .section-divider span{
    font-size:16px;
  }

  .section-divider::before,
  .section-divider::after{
    height:2px;
  }
  .membership-box{
    flex-direction:column;
    text-align:center;
    padding:22px;
    gap:20px;
  }

  .membership-btn{
    width:100%;
    font-size:24px;
    padding:18px;
  }

  .payment-info h3{
    font-size:18px;
  }

  .payment-info p{
    font-size:15px !important;
  }
  .payment-row{
    flex-direction:column;
    gap:18px;
  }

  .payment-card{
    text-align:center;
    font-size:15px;
  }

  .payment-card strong{
    font-size:16px;
  }
}

      `}</style>

      <div className="temple-page">

        <div className="container">

<div className="main-title">

  <h1>FOG COMMUNITY SERVICES</h1>
<div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> 
  <h2>
    Enriching Lives Through Service, Wellness, and Community Care
  </h2>

  <p>
    Festival of Globe (FOG) believes that strong communities are built through compassion, volunteerism, cultural values, and collective responsibility. Through its Charitable & Community Services initiatives, FOG works to improve quality of life by supporting health, wellness, humanitarian assistance, and community outreach programs that benefit individuals and families from all backgrounds.
  </p>

  <p>
    Rooted in the spirit of service and community empowerment, FOG's programs bring together volunteers, healthcare professionals, educators, community leaders, and partner organizations to create positive and lasting impact throughout society.
  </p>
    <h2>
        Our Mission
    </h2>
    <p>
       To inspire service, promote wellness, support vulnerable populations, and strengthen communities through educational, charitable, and humanitarian initiatives. 
    </p>
</div>

{/* SECTION 1 */}

<div className="section">

  <h2 className="section-titles">
    1. FREE HEALTH & WELLNESS FAIR
  </h2>
    <h4>
    <strong>
        Promoting Healthy Communities Through Education and Awareness
    </strong>
    </h4>
    <p>
        The FOG Free Health & Wellness Fair serves as a community platform dedicated to encouraging healthier lifestyles through education, awareness, and access to wellness resources.
    </p>

    <p>
        By bringing together healthcare professionals, wellness practitioners, community organizations, and volunteers, FOG helps individuals gain valuable knowledge about preventive health, healthy living, and personal well-being.
    </p>
    <h4>
    <strong>
        Program Highlights
    </strong>
    </h4>
    <ul>
        <li>Health and wellness education</li>
        <li>Community resource awareness</li>
        <li>Preventive health information</li>
        <li>Healthy lifestyle workshops</li>
        <li>Family wellness programs</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To empower individuals and families with knowledge that supports healthier, happier, and more informed lives.
    </p>
</div>

{/* SECTION 2 */}

<div className="section">

  <h2 className="section-titles">
    2. TOY DRIVE
  </h2>
    <h4>
    <strong>
        Sharing Happiness and Hope with Children
    </strong>
    </h4>
    <p>
        The FOG Toy Drive is a seasonal community initiative dedicated to collecting and distributing toys, books, educational materials, and gifts to children in need.
    </p>

    <p>
        Through the generosity of donors and volunteers, this program seeks to brighten the lives of children and create meaningful moments of joy for families facing financial challenges.
    </p>
    <h4>
    <strong>
        Program Objectives
    </strong>
    </h4>
    <ul>
        <li>Support children and families in need</li>
        <li>Encourage community generosity</li>
        <li>Promote volunteer participation</li>
        <li>Strengthen community bonds</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To ensure every child experiences the joy, hope, and excitement that comes from community care and kindness.
    </p>
</div>

{/* SECTION 3 */}

<div className="section">

  <h2 className="section-titles">
    3. BLANKET DRIVE
  </h2>
    <h4>
    <strong>
        Extending Warmth to Those Who Need It Most
    </strong>
    </h4>
    <p>
        The FOG Blanket Drive focuses on providing warmth, comfort, and essential support to individuals and families experiencing difficult circumstances, particularly during colder seasons.
    </p>

    <p>
        Working alongside community partners and volunteers, this initiative helps distribute blankets and comfort items to those who may benefit from additional assistance.
    </p>
    <h4>
    <strong>
        Program Objectives
    </strong>
    </h4>
    <ul>
        <li>Provide essential comfort resources</li>
        <li>Support vulnerable populations</li>
        <li> Encourage charitable giving</li>
        <li>Foster community compassion</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To demonstrate the power of kindness through simple acts that bring comfort, dignity, and hope.
    </p>
</div>

{/* SECTION 4 */}

<div className="section">

  <h2 className="section-titles">
   4. FOOD FOR THE POOR & HOMELESS
  </h2>
    <h4>
    <strong>
        Nourishing Communities Through Service
    </strong>
    </h4>
    <p>
        The FOG Food for the Poor & Homeless initiative addresses food insecurity by organizing food collection drives, meal service projects, and community partnerships that support individuals and families facing hardship.
    </p>

    <p>
        This program reflects FOG's commitment to helping create stronger communities where compassion and service are shared responsibilities.
    </p>
    <h4>
    <strong>
        Program Activities
    </strong>
    </h4>
    <ul>
        <li>Food donation campaigns</li>
        <li>Community meal service projects</li>
        <li> Volunteer outreach initiatives</li>
        <li>Partnerships with local service organizations</li>
        <li>Hunger awareness efforts</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To help create communities where no individual faces hunger alone and where collective service creates meaningful change.


    </p>
</div>
<div className="section">

  <h2 className="section-titles">
  5. YOG SERVICES
  </h2>
    <h4>
    <strong>
        Yoga • Meditation • Mindfulness • Ayurveda • Integrated Wellness
    </strong>
    </h4>
    <p>
        FOG Yog Services promotes holistic wellness by offering educational programs and experiences inspired by ancient wisdom and modern wellness practices.
    </p>
    <p>
        Through Yoga, Meditation, Mindfulness, Ayurveda, and Integrated Wellness Education, participants are encouraged to explore healthy habits that contribute to physical vitality, emotional resilience, mental clarity, and overall well-being.
    </p>
    <h4>
    <strong>
        Program Areas
    </strong>
    </h4>
    <ul>
        <li>Yoga & Physical Wellness</li>
        <li>Meditation & Inner Well-Being</li>
        <li>Mindfulness Education</li>
        <li>Ayurveda & Lifestyle Awareness</li>
        <li>Integrated Wellness Education</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To inspire individuals to embrace lifelong wellness practices that contribute to healthier and more balanced lives.
    </p>
</div>
{/* SECTION 5 */}

<div className="section">

  <h2 className="section-titles">
   6. MENTAL HEALTH & EMOTIONAL WELLNESS
  </h2>
    <h4>
    <strong>
        Encouraging Resilience, Awareness, and Community Support
    </strong>
    </h4>
    <p>
        TMental and emotional well-being are essential components of a thriving community. The FOG Mental Health & Emotional Wellness initiative seeks to promote awareness, education, and supportive conversations surrounding mental wellness.

    </p>
    <p>
        Through educational programs, workshops, community discussions, and partnerships with qualified professionals, FOG aims to create environments where individuals feel supported, informed, and empowered.
    </p>
    <h4>
    <strong>
        Focus Areas
    </strong>
    </h4>
    <ul>
        <li> Mental wellness education</li>
        <li>Stress reduction awareness</li>
        <li>Emotional resilience programs</li>
        <li>Youth and family support initiatives</li>
        <li> Community wellness conversations</li>
    </ul>
    <h4>
    <strong>
        Our Vision
    </strong>
    </h4>
    <p>
        To foster a culture where mental well-being is understood, valued, and supported through education, compassion, and community engagement.


    </p>
</div>

<div className="section">

  <h2 className="section-titles">
  WHY FOG CHARITABLE & COMMUNITY SERVICES MATTERS
  </h2>
    
    <p>
        Festival of Globe believes that service is a powerful force for positive change. Through charitable outreach, wellness education, humanitarian initiatives, and volunteer engagement, FOG strives to create opportunities that improve lives, strengthen families, and bring communities together.
    </p>
</div>







        </div>

      </div>
    </>
  );
}